import React, { Component, ComponentType, ReactNode, ErrorInfo } from 'react';

type Props = {
  children?: ReactNode;
  errorPage?: ComponentType<{ error: Error }>;
  customAttributes?: Record<string, string | number>;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
};

type State = {
  error: Error | null;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
};

class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    window.DD_RUM &&
      window.DD_RUM.onReady(() => {
        window.DD_RUM.addError(error, { ...errorInfo, ...this.props.customAttributes });
      });
    this.props.onError?.(error, errorInfo);
  }

  render() {
    if (this.state.error && this.props.errorPage) {
      const { errorPage: ErrorPage } = this.props;

      return (
        <>
          <ErrorPage error={this.state.error} />
        </>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
